import { pick } from 'lodash-es'
import jwtDecode from 'jwt-decode'
import { useQuery, gql } from '@apollo/client'

import { AccessToken, Locale } from '@/types'

type Payload = {
  name: string
  locale: Locale
  logo: string
  availableLocales: Locale[]
  legacyCompanyId: string | null
  disable2Fa: boolean
  loading: boolean
}

const QUERY = gql`
  query currentCompany($id: UUID!) {
    companyById(id: $id) {
      id
      name
      locale
      logo
      availableLocales
      companyBindings(first: 1) {
        nodes {
          legacyCompanyId
        }
      }
      companyCompanyTypeByCompanyId {
        companyType {
          id
          disable2Fa
        }
      }
    }
  }
`

const useCompany = (): Payload => {
  const { companyId } = sessionStorage.getItem('accessToken')
    ? jwtDecode<AccessToken>(sessionStorage.getItem('accessToken') as string)
        .user
    : { companyId: null }

  const { data = {}, loading } = useQuery(QUERY, {
    variables: { id: companyId },
    skip: !companyId,
  })

  return {
    ...pick(data?.companyById ?? {}, [
      'name',
      'locale',
      'logo',
      'availableLocales',
    ]),
    legacyCompanyId:
      data?.companyById?.companyBindings?.nodes?.[0]?.legacyCompanyId,
    disable2Fa:
      data?.companyById?.companyCompanyTypeByCompanyId?.companyType?.disable2Fa,
    loading: loading,
  }
}

export default useCompany
